import React, { useState } from 'react';
import { Download } from 'lucide-react';
import { downloadServiceReportPdf } from '../../utils/buildServiceReportPdf';
import './DownloadServiceReportButton.css';

// This same component is used by the Documents page and can be reused
// wherever a customer downloads an administrator-approved report.
export default function DownloadServiceReportButton({ job }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (job?.status !== 'completed' || job?.serviceReportStatus !== 'approved' || !job.serviceReport?.approvedAt) return null;
  const photos = Array.isArray(job.serviceReport?.photos) ? job.serviceReport.photos : [];
  const noApprovedPhotos = photos.length === 0;

  const download = async () => {
    setError('');
    setBusy(true);
    try {
      await downloadServiceReportPdf(job);
    } catch (err) {
      console.error('Service report PDF download failed:', err);
      const message = String(err?.message || '');
      // Safe, actionable messages; don't expose Storage paths or internal errors.
      if (/missing required photos|malformed photo references|approved .*photograph/i.test(message)) {
        setError(message);
      } else {
        setError('Could not generate the report. Contact dispatch@chukologic.com for assistance.');
      }
    } finally {
      setBusy(false);
    }
  };

  return <div className="mt-3">
    <button
      type="button"
      onClick={download}
      disabled={busy}
      className="cl-report-download-button inline-flex min-h-11 items-center justify-center gap-2 rounded-lg px-5 py-3 text-sm font-semibold disabled:opacity-50"
    >
      <Download size={17} aria-hidden="true" />
      <span>{busy ? 'Preparing PDF…' : 'Download PDF report'}</span>
    </button>
    {noApprovedPhotos && (
      <p className="mt-2 max-w-sm text-sm text-[#111111]" role="note">
        This approved report has no attached photographs. Only photos reviewed and included at approval can appear in the PDF.
      </p>
    )}
    {error && <p className="mt-2 max-w-sm text-sm text-red-700" role="alert">{error}</p>}
  </div>;
}
